<template>
	<section id="eventos-home">
		<div class="container eventos-home-content">
			<!-- <h3>Categorías</h3> -->
			<!-- <h1>Buscá eventos por su categoría</h1> -->
			<carousel class="categorias-row-mobile" :autoplay="false" :nav="false" :margin="20" :loop="true" :dots="false" :autoWidth="true" :items="1">
				<router-link class="categoria" :to="{ name: 'categoria-vida-nocturna' }">
					<div class="categoria-left">
						<svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
							<path stroke-linecap="round" stroke-linejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25"></path>
						</svg>
						<span class="categoria-nombre">Vida nocturna</span>
					</div>
					<div class="categoria-right">
						<img src="../../assets/ticketin/VidaNocturna.svg" alt="Vida nocturna">
					</div>
				</router-link>
				<router-link class="categoria" :to="{ name: 'categoria-futbol' }">
					<div class="categoria-left">
						<svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
							<path stroke-linecap="round" stroke-linejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25"></path>
						</svg>
						<span class="categoria-nombre">Fútbol</span>
					</div>
					<div class="categoria-right">
						<img src="../../assets/ticketin/Futbol.svg" alt="">
					</div>
				</router-link>
				<router-link class="categoria" :to="{ name: 'categoria-basquetbol' }">
					<div class="categoria-left">
						<svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
							<path stroke-linecap="round" stroke-linejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25"></path>
						</svg>
						<span class="categoria-nombre">Básquetbol</span>
					</div>
					<div class="categoria-right">
						<img src="../../assets/ticketin/Basquetbol.svg" alt="">
					</div>
				</router-link>
				<router-link class="categoria" :to="{ name: 'categoria-otros' }">
					<div class="categoria-left">
						<svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
							<path stroke-linecap="round" stroke-linejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25"></path>
						</svg>
						<span class="categoria-nombre">Otros</span>
					</div>
					<div class="categoria-right">
						<img src="../../assets/ticketin/Otros.svg" alt="">
					</div>
				</router-link>
			</carousel>
			<div class="categorias-row">
				<router-link class="categoria" :to="{ name: 'categoria-vida-nocturna' }">
					<div class="categoria-left">
						<svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
							<path stroke-linecap="round" stroke-linejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25"></path>
						</svg>
						<span class="categoria-nombre">Vida nocturna</span>
					</div>
					<div class="categoria-right">
						<img src="../../assets/ticketin/VidaNocturna.svg" alt="">
					</div>
				</router-link>
				<router-link class="categoria" :to="{ name: 'categoria-futbol' }">
					<div class="categoria-left">
						<svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
							<path stroke-linecap="round" stroke-linejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25"></path>
						</svg>
						<span class="categoria-nombre">Fútbol</span>
					</div>
					<div class="categoria-right">
						<img src="../../assets/ticketin/Futbol.svg" alt="">
					</div>
				</router-link>
				<router-link class="categoria" :to="{ name: 'categoria-basquetbol' }">
					<div class="categoria-left">
						<svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
							<path stroke-linecap="round" stroke-linejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25"></path>
						</svg>
						<span class="categoria-nombre">Básquetbol</span>
					</div>
					<div class="categoria-right">
						<img src="../../assets/ticketin/Basquetbol.svg" alt="">
					</div>
				</router-link>
				<router-link class="categoria" :to="{ name: 'categoria-otros' }">
					<div class="categoria-left">
						<svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
							<path stroke-linecap="round" stroke-linejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25"></path>
						</svg>
						<span class="categoria-nombre">Otros</span>
					</div>
					<div class="categoria-right">
						<img src="../../assets/ticketin/Otros.svg" alt="">
					</div>
				</router-link>
			</div>
			<h3>Lo que se viene</h3>
			<h1>Los eventos más próximos!</h1>
			<div class="eventos-row" v-if="isCargandoEventos && eventos.length <= 0">
				<SkeletonEventoCard class="evento" v-for="eve in 4" :key="eve" :isDarkMode="true" />
			</div>
			<div class="eventos-row" v-else>
				<EventCardAux :evento="eve" v-for="eve in eventos" :key="eve.Evento.EventoId" @click="irAEvento(eve.Evento.EventoId, eve.Evento.EventoSlug)" />
			</div>
			<div class="show-more-events" v-if="eventos.length === 4">
				<router-link :to="{ name: 'eventos' }">Ver todos</router-link>
			</div>
		</div>
	</section>
</template>

<script>
	import axios from 'axios';
	import { mapState } from "vuex";
	import EventCardAux from "../../components/eventos/EventCardAux.vue";
	import SkeletonEventoCard from "../../components/skeletons/SkeletonEventoCard.vue";
	import carousel from 'vue-owl-carousel'

	export default {
		data() {
			return {
				isCargandoEventos: true,
				eventos: [],
			};
		},
		components: {
			SkeletonEventoCard,
			EventCardAux,
			carousel
		},
		computed: {
			...mapState("AuthModule", ["loggedIn"]),
		},
		async mounted(){
			await this.getEventos();
		},
		methods: {
			irAEvento(id, slug) {
				this.$router.push({ name: 'evento', params: { eventSlug: slug, eventId: id } });
			},
			async getEventos(){
				try {
					this.isCargandoEventos = true

					let response = await axios.post('/WSEventos', {
						Pag: 1,
						Limit: 4,
						IsDesdeRedpagos: false
					});

					if(response.data.ErrorCod === 0){
						this.eventos = response.data.SDTEventos
					}
				} catch (error) {
					console.log('Ocurrió un error al cargar los eventos');
				} finally {
					this.isCargandoEventos = false
				}
			}
		},
	};
</script>

<style lang="scss" scoped>
	#eventos-home {
		width: 100%;
		padding: 0px 0px 60px 0px;
		background-color: var(--color-white);

		.eventos-home-content {
			@include flex(column, flex-start, flex-start);

			h3 {
				font-family: var(--font-sora);
				font-weight: var(--fw-400);
				font-size: 14px;
				color: var(--color-darker);
				line-height: 1.5em;
			}

			h1 {
				font-weight: var(--fw-600);
				margin-bottom: 20px;
				color: var(--color-darker);
				line-height: 1.5em;
			}

			.categorias-row {
				width: 80%;
				display: grid;
				grid-template-columns: repeat(4, 1fr);
				grid-auto-rows: 1fr;
				grid-column-gap: 30px;
				grid-row-gap: 20px;
				margin: -55px auto 70px auto;

				.categoria {
					@include flex(row, space-between, flex-end);
					position: relative;
					width: 100%;
					min-height: 110px;
					background: transparent;
					padding: 12px 12px 12px 20px;
					@include transition(all 0.3s ease);
					border-radius: 8px;
					cursor: pointer;
					background-repeat: no-repeat;
					background-position: 200px 0%;
					background-size: 60%;
					background-color: transparent;
					text-decoration: none;
					background-color: var(--color-primary);
					box-shadow: rgba(0, 0, 0, 0.12) 0px 6px 16px;

					.categoria-left{
						@include flex(column, space-between, flex-start);
						height: 100%;
						min-height: 50px;

						svg {
							color: var(--color-darker);
							margin-top: 4px;
							width: 19px;
						}

						.categoria-nombre{
							color: var(--color-darker);
							font-weight: var(--fw-600);
							font-size: 16px;
							font-family: var(--font-sora);
						}
					}

					.categoria-right{
						@include flex(column, flex-end, flex-start);

						img{
							position: absolute;
							bottom: 10px;
							right: 5px;
							height: 105%;
						}

						i{
							font-size: 24px;
							color: var(--color-darker);
						}
					}

					&:hover {
						// background-image: url('../../assets/pattern.svg');
						background-repeat: no-repeat;
						background-position: 100px 50%;
						background-size: 120%;
						// box-shadow: 0.25rem 0.25rem 0 var(--color-primary);
						border-color: var(--color-darker);
						background-color: var(--color-darker);
						// opacity: .9;

						.categoria-left{
							.categoria-nombre{
								font-weight: var(--fw-700);
								color: var(--color-white);
							}

							svg {
								color: var(--color-white);
							}
						}
					}
				}
			}

			.categorias-row-mobile {
				display: none;
				margin: -65px 0px 40px 0px;
				// width: 100%;

				.categoria {
					@include flex(row, space-between, flex-end);
					position: relative;
					width: 290px;
					min-height: 130px;
					height: 130px;
					background: transparent;
					padding: 12px 12px 12px 20px;
					@include transition(all 0.3s ease);
					border-radius: 8px;
					cursor: pointer;
					// border: 1px solid var(--color-black);
					// transform: translate(-0.25rem, -0.25rem);
					// box-shadow: 0.25rem 0.25rem 0 var(--color-black);
					background-color: transparent;
					margin-top: 4px;
					margin-left: 4px;
					align-items: stretch;
					text-decoration: none;
					background-color: var(--color-primary);
					margin-bottom: 5px;
					// box-shadow: rgba(0, 0, 0, 0.12) 0px 6px 16px;

					.categoria-left{
						@include flex(column, space-between, flex-start);
						align-items: stretch;
						width: 40%;

						svg {
							color: var(--color-darker);
							margin-top: 4px;
							width: 19px;
						}

						.categoria-nombre{
							color: var(--color-darker);
							font-weight: var(--fw-600);
							font-size: 16px;
							font-family: var(--font-sora);
						}
					}

					.categoria-right{
						position: relative;
						@include flex(row, flex-end, flex-end);
						width: 60%;
						height: 100%;

						img{
							max-width: 98px;
							max-height: 100%;
						}

						i{
							font-size: 24px;
							color: var(--color-darker);
						}
					}

					&:hover {
						box-shadow: 0.25rem 0.25rem 0 var(--color-primary);
						border-color: var(--color-primary);

						.categoria-left{
							.categoria-nombre{
								font-weight: var(--fw-700);
							}
						}
					}
				}
			}

			.eventos-row {
				width: 100%;
				display: grid;
				grid-template-columns: repeat(4, 1fr);
				// grid-auto-rows: 1fr;
				grid-column-gap: 20px;
				grid-row-gap: 20px;
				margin: 10px 0px;
				// gap: 20px;
				// @include flex(row, space-between, center);
				// flex-wrap: wrap;
			}

			.show-more-events{
				width: 100%;
				@include flex(row, flex-end, center);
				margin-top: 6px;

				a{
					text-decoration: none;
					color: var(--color-darker);
					font-weight: var(--fw-600);
					text-transform: uppercase;
					font-size: 11px;
					letter-spacing: 0.3px;
					@include transition(all .2s);

					&:hover{
						text-decoration: underline;
					}
				}
			}
		}
	}

	@media screen and (max-width: 1400px){
		#eventos-home{
			.eventos-home-content{
				padding-left: 24px;
				padding-right: 24px;

				// .categorias-row-mobile{
				// 	margin: 0px 0px 40px 0px;
				// }
			}
		}
	}

	@media screen and (max-width: 1300px){
		#eventos-home{
			.eventos-home-content{
				.eventos-row{
					grid-template-columns: repeat(3, 1fr);
				}
			}
		}
	}

	@media screen and (max-width: 1200px){
		#eventos-home{
			.eventos-home-content{
				.categorias-row{
					display: none;
				}

				.categorias-row-mobile{
					@include flex(row, flex-start, center);
				}
			}
		}
	}

	@media screen and (max-width: 890px){
		#eventos-home{
			.eventos-home-content{
				.eventos-row{
					grid-template-columns: repeat(2, 1fr);
				}
			}
		}
	}

	@media screen and (max-width: 700px){
		#eventos-home{
			.eventos-home-content{
				.categorias-row-mobile{
					.categoria{
						width: 230px;
					}
				}
			}
		}
	}

	@media screen and (max-width: 620px){
		#eventos-home{
			.eventos-home-content{
				.eventos-row{
					grid-template-columns: repeat(1, 1fr);
				}
			}
		}
	}
</style>